import Vue from 'vue'
import Vuex from 'vuex'
import tabView from './tabView.js'
import user from './user.js'
import point from './point.js'
import viewTree from './viewTree.js'
import data from './data.js'

Vue.use(Vuex)

export default new Vuex.Store({
      state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  modules: {
    tabView,
    user,
    viewTree,
    point,
    data
  }
})
